import {
    createObservableDataAction,
    IAction,
    ICreateActionContext,
    IActionContext,
    CacheType,
    IActionInput
} from '@msdyn365-commerce/core';
import { ProductsDataActions, retailAction } from '@msdyn365-commerce/retail-proxy';
import { getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
import { IProductInfo } from './DataServiceEntities.g';
import { getProductInfoInput } from './DataActionExtension.g';

/**
 * GetProductInfoInput
 */
class GetProductInfoInput implements IActionInput {
    public readonly productId: number;

    constructor(productId: number) {
        this.productId = productId;
    }

    public getCacheKey = () => `${this.productId}`;
    public getCacheObjectType = () => 'HEI-ProductInfo';
    public dataCacheType = (): CacheType => 'application';
}

async function action(input: GetProductInfoInput, ctx: IActionContext): Promise<IProductInfo> {
    const product = await ProductsDataActions.getByIdAsync(
        { callerContext: ctx },
        input.productId,
        ctx.requestContext.apiSettings.channelId
    );

    let itemId = product?.ItemId;
    const newSkuInfo = product.ExtensionProperties?.find(ep => ep.Key === 'NewSku')?.Value?.StringValue;
    if (newSkuInfo) {
        const newProductSku = newSkuInfo.split(':')[1];
        if (newProductSku) {
            itemId = newProductSku;
        }
    }

    if (!itemId) {
        throw new Error('Unable to get product SKU');
    }

    const ProductInfoInput = getProductInfoInput(itemId);
    return retailAction(ProductInfoInput, ctx);
}

/**
 * Get Warranty Info Data Action
 */
export default createObservableDataAction({
    action: <IAction<IProductInfo>>action,
    input: (context: ICreateActionContext) => {
        const productId = getSelectedProductIdFromActionInput(context);
        if (productId) {
            return new GetProductInfoInput(+productId);
        } else {
            throw new Error('Unable to create GetProductInfoInput, no productId found on module config or query');
        }
    }
});
